/* eslint-disable no-nested-ternary */
import { FormInstance } from 'antd';
import i18n from '@app/i18n';
import { APIError, ResponseError } from '@data/index';
import { showDefaultErrorToast } from './showDefaultErrorToast.helper';

const validationErrors = [
  'must be one of the following values',
  'must be a boolean string',
  'must be a valid ISO 8601 date string',
  'must be an email',
  'must be a UUID',
  'must be an array',
  'must be a boolean value',
  'must be a Date instance',
  'must be one of the following values: $constraint2',
  'must be a number conforming to the specified constraints',
  'must be a string',
];

const getErrorTranslation = (errorString: string): string => {
  const translatedError = validationErrors.find((el) => errorString?.includes(el));

  return i18n.t([`beErrors.${translatedError}`, errorString]);
};
export const setFormError = <T extends Record<string, string[]>>(
  error: string,
): { errors?: string[]; name: string }[] => {
  const parsedError: ResponseError<T> = JSON.parse(error);

  return Object.keys(parsedError).map((key) => ({
    name: key,

    errors: parsedError[key]
      ? Array.isArray(parsedError[key])
        ? [getErrorTranslation(parsedError[key]?.[0] as string)]
        : [getErrorTranslation(parsedError[key] as string)]
      : [],
  }));
};

export const useHandleFormErrors = <T extends object>(
  error: APIError<T>,
  form: FormInstance<any>,
) => {
  if (error.response?.data.message === 'ValidationError' && error.response?.data.error) {
    form.setFields(setFormError(error.response?.data.error));
  } else {
    showDefaultErrorToast(error);
  }
};
